<div class="modal-header shadow-sm">
  <div>
    <h6 class="modal-title mb-0">{{ title || brief?.fileName }}</h6>
    @if (subtitle) {
      <p class="text-muted small mb-0 mt-1">{{ subtitle }}</p>
    }
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body scrollbar-primary thin">
  @if (loading) {
    <app-loader [loader]="loading"></app-loader>
  } @else if (isImage && brief?.url) {
    <img [src]="brief?.url" [alt]="brief?.fileName" class="img-fluid rounded" />
  } @else if (isText && brief?.content) {
    <pre class="brief-prompt">{{ brief?.content }}</pre>
  } @else if (brief?.url) {
    <a [href]="brief?.url" target="_blank" rel="noopener">Open {{ brief?.fileName }}</a>
  } @else {
    <p class="text-muted mb-0">Preview is not available for this file type.</p>
  }
</div>
<div class="modal-footer pt-0 d-flex justify-content-between">
  <span class="text-muted small">Watch developers use this file to create the watch app variation.</span>
  <button type="button" class="btn btn-gray-light" (click)="close()">Close</button>
</div>
